// extracted by mini-css-extract-plugin
export default {"container":"styles_container__l3BVh","image":"styles_image__WVRD3","cards":"styles_cards__-oD0s","card":"styles_card__3BGLJ","hint":"styles_hint__twQ8E"};